import { useSelector } from "react-redux";

import { ComponentMission } from "@components";
import { selectAuth } from "@redux";

export const PageMission = () => {
    //redux states
    const { userInfo } = useSelector(selectAuth);

    //variable
    const memberTier = userInfo?.memberTier;

    return (
        <ComponentMission
            memberTier={memberTier} avatar={""} fullName={""} />
    );
};
